import(/* webpackMode: "eager", webpackExports: ["LegalShell"] */ "/app/src/components/legal/legal-shell.tsx");
